import { ParseDate } from "../../Helpers/DateHelper";

export default function Tag({ tag }) {
  var dateTime = tag?.createdAt && ParseDate(tag.createdAt);
  return tag?.createdAt ? (
    <span className="tag">
      {dateTime.date} - {dateTime.time} / {tag.createdBy}
    </span>
  ) : null;
}
